module.exports = "<div>\n  <div style=\"display: block\">\n    <canvas #chartS2000W></canvas>\n  </div>\n</div>\n\n"